export enum DonorAction {
    Divider = -1,
    Edit = 0,
    OrderTissueTyping = 1,
    UtilizeBulkCheekSwabKit = 2,
    Voucher = 3,
    SendEmail = 5,
    SeeDash = 6,
    Apply = 7,
    Delete = 8,
    CryoOrder = 9,
    ConvertDonorType = 10,
    View = 11,
    VoucherRecipient = 12,
    PrintRequisition = 13,
    StartExpertSystem = 14,
    AddMicrositeVoucherHolder = 15
}